import type { FestivalEventType } from '@api';
import type { ScheduleEventData } from '@mantine/schedule';
import dayjs from 'dayjs';
import type { PayloadType } from '../../../../types';

type GetScheduledEventFromFestivalDataReturnType =
  ScheduleEventData<PayloadType>[];

export const getScheduledEventFromFestivalData = (
  records: FestivalEventType[]
): GetScheduledEventFromFestivalDataReturnType => {
  return records.map((festival) => {
    return {
      id: `festival-${festival.festival.id}-${festival.startDate}`,
      title: festival.festival.name,
      start: dayjs(festival.startDate).format('YYYY-MM-DD 00:00:00'),
      end: dayjs(festival.endDate).add(1, 'day').format('YYYY-MM-DD 00:00:00'),
      color: 'green',
      payload: {
        type: 'FESTIVAL',
        festival,
      },
    };
  });
};
